<template>
    <v-card elevation="0" height="100%" class="d-flex justify-space-between align-center myprovet-main-card">
        <v-card-text>
            <v-row v-if="selectorOptions.cardsInFirstRow == 2">
                <v-col cols="12" sm="6" md="6" class="pr-1 py-1">
                    <v-card elevation="0" class="myprovet-inner-card">
                        <v-card-text></v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="pl-1 py-1">
                    <v-card elevation="0" class="myprovet-inner-card">
                        <v-card-text></v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-else>
                <v-col cols="12" sm="12" md="12" class="py-1">
                    <v-card elevation="0" class="myprovet-inner-card">
                        <v-card-text></v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="selectorOptions.cardsInSecondRow == 2">
                <v-col cols="12" sm="6" md="6" class="pr-1 py-1">
                    <v-card elevation="0" class="myprovet-inner-card">
                        <v-card-text></v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="pl-1 py-1">
                    <v-card elevation="0" class="myprovet-inner-card">
                        <v-card-text></v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-else>
                <v-col cols="12" sm="12" md="12" class="py-1">
                    <v-card elevation="0" class="myprovet-inner-card">
                        <v-card-text></v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="selectorOptions.cardsInThirdRow == 2">
                <v-col cols="12" sm="6" md="6" class="pr-1 py-1">
                    <v-card elevation="0" class="myprovet-inner-card">
                        <v-card-text></v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="pl-1 py-1">
                    <v-card elevation="0" class="myprovet-inner-card">
                        <v-card-text></v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-else>
                <v-col cols="12" sm="12" md="12" class="py-1">
                    <v-card elevation="0" class="myprovet-inner-card">
                        <v-card-text></v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="selectorOptions.numberOfRows == 4">
                <v-col cols="12">
                    <v-row v-if="selectorOptions.cardsInFourthRow == 2">
                        <v-col cols="12" sm="6" md="6" class="pr-1 py-1">
                            <v-card elevation="0" class="myprovet-inner-card">
                                <v-card-text></v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="pl-1 py-1">
                            <v-card elevation="0" class="myprovet-inner-card">
                                <v-card-text></v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row v-else>
                        <v-col cols="12" sm="12" md="12" class="py-1">
                            <v-card elevation="0" class="myprovet-inner-card">
                                <v-card-text></v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'AppLayoutSelector',
    props: {
        selectorOptions: {
            numberOfRows: null,
            cardsInFirstRow: null,
            cardsInSecondRow: null,
            cardsInThirdRow: null,
            cardsInFourthRow: null,
        },
    },
};
</script>

<style scoped>
.myprovet-main-card {
    background: #e7f4fa;
    border-radius: 16px;
}

.myprovet-inner-card {
    background: #154579;
    border-radius: 8px;
    height: 4vh;
}
</style>
